import { PendingInvitationsBanner } from "@/shell/PendingInvitationsBanner";
import { Vide } from "@/shared/ui";
import { Mail } from "@/shared/ui/icons";

interface AgencyStepProps {
  /** Conservé pour la compat de signature avec OnboardingScreen ; non utilisé
   *  depuis que la création d'organisation est désactivée. */
  onCompleted: () => void;
}

/**
 * Onboarding — création d'organisation DÉSACTIVÉE (2026-06-30).
 *
 * La plateforme est restreinte à l'unique organisation existante (Xeyla). Un
 * nouvel utilisateur ne peut plus créer d'agence : il doit être invité. On
 * affiche un avis + la bannière d'invitations en attente (s'il en a une, il
 * peut l'accepter directement depuis ici). Le verrou serveur correspondant
 * vit dans `accounts.createMyOrganization` (throw ORG_CREATION_DISABLED).
 */
export function AgencyStep(_props: AgencyStepProps) {
  return (
    <div>
      <PendingInvitationsBanner variant="card" />

      <Vide
        icone={<Mail />}
        titre="Accès sur invitation"
        texte="La création d'organisation est désactivée. Pour accéder au cockpit, demande à être invité dans une organisation existante."
      />
    </div>
  );
}
